import { useEffect, useState } from 'react';

/**
 * ¿La ventana es de teléfono? (`sm` de Tailwind = 640px)
 *
 * Nace el 19-sep-2026 con el barrido móvil de Clases: lo que se puede resolver con clases
 * responsivas se resuelve en CSS; esto es solo para los pocos casos en que un valor NUMÉRICO
 * tiene que cambiar con el ancho (el `minColWidth` de la rejilla semanal, por ejemplo).
 *
 * Escucha el cambio, así que rotar el teléfono o abrir las DevTools no deja el valor viejo.
 */
export function useEsMovil(maxAncho = 639): boolean {
  const [esMovil, setEsMovil] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia?.(`(max-width: ${maxAncho}px)`).matches);
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${maxAncho}px)`);
    const on = () => setEsMovil(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [maxAncho]);
  return esMovil;
}
